import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="accordion"
export default class extends Controller {
  static values = {
    expanded: Boolean,
    topic: String,
    scroll: Boolean
  }

  static classes = ['collapsed', 'expanded', 'area', 'state']
  static targets = ['area', 'state']

  connect() {
    if (this.expandedValue) {
      this.expand()
    }
  }

  toggle(event) {
    event.preventDefault()

    if (this.expandedValue) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  toggleForCheckbox({ target }) {
    if (target.checked) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  react({ detail: { topics } }) {
    if (this.hasTopicValue && topics.includes(this.topicValue)) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  expand() {
    this.element.classList.remove(...this.collapsedCss)
    this.element.classList.add(...this.expandedCss)

    if (this.hasAreaClass && this.hasAreaTarget) {
      this.areaTarget.classList.add(...this.areaClasses)
    }

    if (this.hasStateClass && this.hasStateTarget) {
      this.stateTarget.classList.add(...this.stateClasses)
    }

    this.expandedValue = true
    this.scroll()
  }

  scroll() {
    if (this.scrollValue) {
      this.areaTarget.lastElementChild.scrollIntoView()
    }
  }

  collapse() {
    this.element.classList.remove(...this.expandedCss)
    this.element.classList.add(...this.collapsedCss)

    if (this.hasAreaClass && this.hasAreaTarget) {
      this.areaTarget.classList.remove(...this.areaClasses)
    }

    if (this.hasStateClass && this.hasStateTarget) {
      this.stateTarget.classList.remove(...this.stateClasses)
    }

    this.expandedValue = false
  }

  get expandedCss() {
    if (this.hasExpandedClass) {
      return this.expandedClasses
    } else {
      return ["accordion--expanded"]
    }
  }

  get collapsedCss() {
    if (this.hasCollapsedClass) {
      return this.collapsedClasses
    } else {
      return ["accordion--collapsed"]
    }
  }
}
